module.exports = __webpack_public_path__ + "static/media/mosfet-board-tutorial-video-link-img.66ee1e63.png";